/**
 * @generated SignedSource<<32df6e83baaf72977e3e095da2daeeef>>
 * @relayHash d32c91de1a0c938d346ccddd080ca54d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmProjectMenuWrapper_SidebarQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type JsmProjectMenuWrapper_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type JsmProjectMenuWrapper_SidebarQuery = {
  response: JsmProjectMenuWrapper_SidebarQuery$data;
  variables: JsmProjectMenuWrapper_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
  "kind": "LinkedField",
  "name": "hiddenMenuItems",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "itemId"
            }
          ]
        }
      ]
    }
  ]
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "558440f5dc1d01ea96ee5362ed3db743ce602559ebd97a47035ce2ee9f71acde",
    "metadata": {},
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0ce17ff55164386bf24d619856f960f5";

export default node;
